export default "__VITE_ASSET__CPrkbUZD__"